export default __webpack_public_path__ + "static/media/0031.ee869f43.png";